import { render, staticRenderFns } from "./DialogPassword.vue?vue&type=template&id=5a13c7d0&scoped=true"
import script from "./DialogPassword.vue?vue&type=script&lang=js"
export * from "./DialogPassword.vue?vue&type=script&lang=js"
import style0 from "./DialogPassword.vue?vue&type=style&index=0&id=5a13c7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a13c7d0",
  null
  
)

export default component.exports